import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useBooleanState } from 'react-use-object-state';
import { IntegrationDefinitionsQuery } from './graphql';
import { IntegrationDefinition, IntegrationDefinitionsResult } from './types';

const dedupeDefinitions = (definitions: IntegrationDefinition[]) =>
  definitions.filter(
    (definition, index) =>
      definitions.findIndex((d) => d.id === definition.id) === index
  );

export default function useIntegrationDefinitions() {
  const { data, loading, fetchMore } = useQuery<IntegrationDefinitionsResult>(
    IntegrationDefinitionsQuery
  );

  const loadingMore = useBooleanState(true);

  useEffect(() => {
    if (data && data.integrationDefinitions.pageInfo.hasNextPage) {
      fetchMore({
        query: IntegrationDefinitionsQuery,
        variables: { cursor: data.integrationDefinitions.pageInfo.endCursor },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const previousDefinitions =
            previousResult.integrationDefinitions.definitions;
          const newDefinitions =
            fetchMoreResult?.integrationDefinitions.definitions || [];
          const newPageInfo = fetchMoreResult?.integrationDefinitions
            .pageInfo || { hasNextPage: false, endCursor: null };

          return {
            integrationDefinitions: {
              definitions: dedupeDefinitions([
                ...previousDefinitions,
                ...newDefinitions,
              ]),
              pageInfo: newPageInfo,
              __typename: previousResult.integrationDefinitions.__typename,
            },
          };
        },
      });
    }
    if (data && !data.integrationDefinitions.pageInfo.hasNextPage) {
      loadingMore.setFalse();
    }
  }, [data]);

  return { data, loading: loading || loadingMore.state };
}
